import { LegalDocumentsTermLabelTranslations } from '../AcceptTrade/AcceptTradeSubscriptionWrapper/components/AcceptBuyTradeDisclaimerWrapper/components/LegalDocumentsTermLabel';
import { AcceptOfferNonComplexProductsTermsTranslations } from '../AcceptTrade/AcceptTradeSubscriptionWrapper/components/AcceptBuyTradeDisclaimerWrapper/components/AcceptOfferNonComplexProductsTerms';
import { FeesListTranslations } from '../Reusable/FeesList/FeesList';
import { TradeTaxSummaryTranslations } from '../Reusable/TradeTaxSummary/TradeTaxSummary';

export type AcceptSwapScreenTranslations = {
  CryptoAsset: string;
  MetalAsset: string;
  StockAsset: string;
  EtfAsset: string;
  EtcAsset: string;
  eur: string;
  aed: string;
  subTotal: string;
  total: string;
  priceGuarantee: string;
  feesIncluded: string;
  offerFeesDescription: string;
  swapAmount: string;
  swapVolume: string;
  tradeFee: string;
  tradeFeeInclVAT: string;
  offerPrice: string;
  swapNow: string;
  summary: string;
  get: string;
  payWith: string;
  swapSuccessTitle: string;
  viewTransaction: string;
  poweredByBpfs: string;
  swapFailedTitle: string;
  swapFailedSubtitle: string;
  backToPortfolioButton: string;
  swapSubmittedTitle: string;
  goToPortfolio: string;
  successBuyTitle: string;
  successSaleTitle: string;
  okGoToPortfolio: string;
  pendingBuyPageTitle: string;
  pendingSellPageTitle: string;
  transactionFailTitle: string;
  failCardText: string;
  sellScreenTaxNotFinalWarning: string;
  areYouSureTradeCancel: string;
  noDontCancel: string;
  yesGoToPortfolio: string;
  poweredByTenant: string;
} & FeesListTranslations &
  TradeTaxSummaryTranslations &
  LegalDocumentsTermLabelTranslations &
  AcceptOfferNonComplexProductsTermsTranslations & {
    investingRiskToggle: string;
    stocksToggleNotAppropriate: string;
  };

const AcceptSwapScreenTranslations: AcceptSwapScreenTranslations = {
  CryptoAsset: 'dashboard_portfolio_crypto',
  riskWarningText1: 'risk_warning_text_1',
  riskWarningText2: 'risk_warning_text_2',
  MetalAsset: 'dashboard_portfolio_metals',
  StockAsset: 'currency_filter_stock',
  EtfAsset: 'currency_filter_ETF',
  EtcAsset: 'currency_filter_commodities',
  eur: 'eur_label',
  aed: 'aed_label',
  subTotal: 'subtotal',
  total: 'total',
  priceGuarantee: 'price_guarantee',
  feesIncluded: 'fees_included',
  offerFeesDescription: 'offer_fees_description',
  swapAmount: 'swap_amount',
  swapVolume: 'swap_volume',
  tradeFee: 'trade_fee',
  tradeFeeInclVAT: 'trade_fee_incl_vat',
  offerPrice: 'offer_price',
  taxDetails: 'tax_details',
  taxWitheld: 'tax_withheld',
  youReceive: 'you_receive',
  cryptoTaxInfoText1: 'crypto_tax_info_text_line_1',
  cryptoTaxInfoText2: 'crypto_tax_info_text_line_2',
  taxSystemOfflineWarningTitle: 'tax_system_offline_warning_title',
  taxSystemOfflineWarningSubtitle: 'tax_system_offline_warning_subtitle',
  swapNow: 'swap_now',
  summary: 'summary',
  get: 'get',
  payWith: 'pay_with',
  investingRiskToggle: 'investing_risk_toggle',
  stocksToggleNotAppropriate: 'stocks_toggle_not_appropriate_description',
  legalTogglePartOne: 'I_agree_to_the',
  legalToggleLastPart: 'legal_toggle_last_part',
  derivativeContract: 'derivative_contract',
  andConfirmThatIhaveReadAndUnderstoodThe:
    'and_confirm_that_I_have_read_and_understood_the',
  prospectus: 'prospectus',
  keyInformationDocument: 'key_information_document',
  investorInformationDocument: 'investor_information_document',
  and: 'and',
  costTransparencyDocuments: 'cost_transparency_document',
  costTransparencyTitle: 'cost_transparency_title',
  kidDisclaimerPartOne: 'kid_disclaimer_part_one',
  kidDisclaimerPartTwo: 'kid_disclaimer_part_two',
  kidTitle: 'key_information_document_title',
  swapSuccessTitle: 'swap_success_title',
  viewTransaction: 'view_transaction',
  poweredByBpfs: 'powered_by_bpfs',
  swapFailedTitle: 'transaction_fail_title',
  swapFailedSubtitle: 'savings_plan_failed_title',
  backToPortfolioButton: 'back_to_portfolio_button',
  swapSubmittedTitle: 'swap_submitted_title',
  goToPortfolio: 'go_to_portfolio',
  successBuyTitle: 'success_buy_title',
  successSaleTitle: 'success_sale_title',
  okGoToPortfolio: 'ok_go_to_portfolio',
  pendingBuyPageTitle: 'pending_buy_title',
  pendingSellPageTitle: 'pending_sell_title',
  transactionFailTitle: 'transaction_fail_title',
  failCardText: 'general_error_message_title',
  sellScreenTaxNotFinalWarning: 'sell_screen_tax_not_final_warning',
  areYouSureTradeCancel: 'are_you_sure_trade_cancel_@tenant',
  noDontCancel: 'no_dont_cancel',
  yesGoToPortfolio: 'yes_go_to_portfolio',
  poweredByTenant: 'powered_by_@tenant',
};

export const getAcceptSwapTranslations = (
  transUtil: (param: string) => string,
): AcceptSwapScreenTranslations => {
  return Object.entries(AcceptSwapScreenTranslations).reduce(
    (acc, [key, value]) => {
      acc[key as keyof AcceptSwapScreenTranslations] = transUtil(value);

      return acc;
    },
    {} as AcceptSwapScreenTranslations,
  );
};
